export interface NavState {
  country: string;
  domain: string;
  gatewayUrl: string;
  searchSuggestions: string[];
  membersProps: Record<string, unknown> | null;
  welcomePopup?: WelcomePopupConfig;
}

export interface WelcomePopupNewsletterConfig {
  enabled: boolean;
  config: Record<string, string>;
}

export interface WelcomePopupConfig {
  newsletter: WelcomePopupNewsletterConfig;
}

interface DataPayload {
  country?: string;
  domain?: string;
  searchSuggestions?: string[];
  gatewayUrl?: string;
  welcomePopup?: WelcomePopupConfig;
}

declare global {
  // window.membersPropsJson is emitted by the finder-theme mu-plugin
  // (inc/enviroment/index.php) — it is shared infra outside our control,
  // so we still read it from the window.
  interface Window {
    membersPropsJson?: string;
    registerEngagement?: (engagementName: string) => void;
  }
}

function readDataIsland(): DataPayload {
  const el = document.getElementById('gn-data');
  if (!el?.textContent) return {};
  try {
    return JSON.parse(el.textContent) as DataPayload;
  } catch {
    return {};
  }
}

function readMembersProps(): Record<string, unknown> | null {
  const raw = window.membersPropsJson;
  if (typeof raw !== 'string' || raw === '') return null;
  try {
    return JSON.parse(raw) as Record<string, unknown>;
  } catch {
    return null;
  }
}

export function readWindowData(): NavState {
  const data = readDataIsland();

  return {
    country: data.country ?? 'au',
    domain: data.domain ?? location.origin,
    gatewayUrl: data.gatewayUrl ?? '',
    searchSuggestions: data.searchSuggestions ?? [],
    membersProps: readMembersProps(),
    welcomePopup: data.welcomePopup,
  };
}
